import request from '@/utils/request'

// 单位列表
export function getInfoList(query) {
  return request({
    url: '/v1.0/iwrs/msg/all',
    method: 'get',
    params: query
  })
}

// 可以导入的列表
export function importInfos(query) {
  return request({
    url: '/v1.0/iwrs/msg/can_import_all',
    method: 'get',
    params: query
  })
}

// 导入
export function inInfo(data) {
  return request({
    url: '/v1.0/iwrs/msg/import',
    method: 'post',
    data
  })
}

// 删除
export function delInfo(data) {
  return request({
    url: '/v1.0/iwrs/msg/delete',
    method: 'delete',
    data
  })
}

// 编辑
export function editInfo(data) {
  return request({
    url: '/v1.0/iwrs/msg/update',
    method: 'put',
    data
  })
}

// 详情
export function detailInfo(query) {
  return request({
    url: '/v1.0/iwrs/msg/detail',
    method: 'get',
    params: query
  })
}
